import Media from './media';
import Richtext from './richtext';

type Item = {
  background: Media;
  media: Media;
  subtitle: Richtext;
  title: string;
  fontColor: string;
};

export class Features {
  fontColor: string;
  items: Item[];
  lockAt: number;
  phoneFrame: Media | null;
  scrollSpeed: number;
  title: string;
  wheelCount: number;

  constructor(props: any) {
    this.phoneFrame = props.phoneFrame ? new Media(props.phoneFrame) : null;
    this.title = props.title;
    this.fontColor = props.fontColor;
    this.lockAt = props.lockAtPixelRange;
    this.scrollSpeed = props.scrollSpeed || 50;
    this.wheelCount = 0;
    this.items = props.itemsCollection?.items?.map((i: any) => ({
      background: i.backgroundMedia ? new Media(i.backgroundMedia) : null,
      media: i.mainMedia ? new Media(i.mainMedia) : null,
      subtitle: i.subtitle ? new Richtext(i.subtitle) : null,
      title: i.title,
      fontColor: i.fontColor
    }));
  }

  setWheelCount(count: number) {
    this.wheelCount = count;
  }
}

export default Features;
